<template>
<div id="gfo_switchsupport_app">
    <p>Wählen Sie den Kündigungsbrief, den Sie erstellen möchten:</p>
    <ul class="switchsupport_choices">
        <li @click="setComponent('CancelDefault', {type: 'internet'})">Internet kündigen</li>
        <li @click="setComponent('CancelDefault', {type: 'phone'})">Telefon kündigen ohne Rufnummernportierung</li>
        <li @click="setComponent('CancelDefault', {type: 'television'})">TV kündigen</li>
        <li @click="setComponent('CancelDefault', {type: 'cable'})">Kabelanschluss kündigen</li>
    </ul>
    <div v-if="current_component" :is="current_component" v-bind="current_props"></div>
</div>
</template>
<script>
import CancelDefault from '@/components/CancelDefault.vue';
export default {
    name: 'App',
    data: function(){
        return {
        }
    },
    components: {
        CancelDefault
    },
    computed: {
        current_component: function(){
            return this.$store.state.current_component;
        },
        current_props: function(){
            return this.$store.state.current_component_props;
        },
    },
    methods: {
        setComponent: function(name, props){
          this.$store.commit('current_component', {component: name, props: props});
        },
    },
    created: function(){
        let that = this;
        if ('' != this.$store.state.order_reference){
            that.$store.state.ApiService.sendRequest('GET', '/orders/'+that.$store.state.order_reference, null, function(dat, err, stat){
                if (404 == stat){
                    store.commit('order_reference', '');
                    store.commit('order', null);
                } else {
                    that.$store.commit('order', dat);
                }
            });
        }
        
    },

}
</script>

